/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $GetUserTermsResponse = {
  type: 'all-of',
  contains: [{
    type: 'ListResponse',
  }, {
    properties: {
      data: {
        type: 'array',
        contains: {
          type: 'UserTerm',
        },
        isRequired: true,
      },
    },
  }],
} as const;
